import { FieldValues, UseFormSetError } from 'react-hook-form';
import { handleErrorForm } from '@services/api';
import { Collaborator } from 'interfaces/Collaborator';
import {
  CollaboratorFilters,
  TerminateParams,
  create,
  list,
  remove,
  retrieve,
  terminate,
  update,
} from './calls';

export * from './calls';

export default class CollaboratorAPICaller {
  static adaptToAPI = (data: FieldValues) => {
    const collaborator = {
      ...data,
    };

    return collaborator as Collaborator;
  };

  static list = async (filters: CollaboratorFilters) => {
    const {
      data: { collaborators },
    } = await list(filters);

    return {
      ...collaborators,
      result: collaborators.result,
    };
  };

  static fetch = async (editId: string) => {
    const {
      data: { collaborator },
    } = await retrieve(editId);

    return collaborator;
  };

  static createOrUpdate = async (
    data: FieldValues,
    setError: UseFormSetError<FieldValues>
  ) => {
    const method = data.id ? update : create;

    const result = method(this.adaptToAPI(data)).catch(
      handleErrorForm(setError)
    );

    return result;
  };

  static terminate = async (id: string, params: TerminateParams) => {
    const { data } = await terminate(id, params);

    return data;
  };

  static remove = async (id: string) => {
    const { data } = await remove(id);

    return data;
  };
}
